import React, { createContext, useState, useEffect, useContext } from 'react';
import { authService } from '../services/api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const res = await authService.getUser();
          setUser(res.data);
        } catch (err) {
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };
    loadUser();
  }, []);

  const login = async (email, password) => {
    const res = await authService.login({ email, password });
    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
      const userRes = await authService.getUser();
      setUser(userRes.data);
    }
    return res.data;
  };

  const register = async (name, email, password, isOver13, website = '') => {
    const res = await authService.register({ name, email, password, isOver13, website });
    return res.data;
  };

  const verify = async (email, code) => {
    const res = await authService.verify({ email, code });
    if (res.data.token) {
      localStorage.setItem('token', res.data.token);
      const userRes = await authService.getUser();
      setUser(userRes.data);
    }
    return res.data;
  };

  const resendVerification = async (email) => {
    const res = await authService.resendVerification({ email });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  const refreshUser = async () => {
      try {
          const res = await authService.getUser();
          setUser(res.data);
      } catch (err) {
          console.error("Error refreshing user", err);
      }
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, verify, resendVerification }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
